import ApiClient from '../helpers/ApiClient';

// Get the current popup banner image URL
export const getPopupBanner = async () => {
    try {
        const response = await ApiClient.get('/homePage/homePage/getPopUpImageAdmin');
        return response;
    } catch (error) {
        throw error;
    }
};

// Update the popup banner image
export const updatePopupBanner = async (imageFile, id) => {
    try {
      const formData = new FormData();
      formData.append('file', imageFile);
  
      const response = await ApiClient.put(`/homePage/homePage/updatePopUpImage/${id}`, formData, {  // Modified URL
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  };


  export const toggleActiveStatus = async (id, status) => {
    try {
        const response = await ApiClient.put(`/homePage/homePage/enablingDisablingOfImage/${id}`, { status });
        console.log("Toggle Active Status", response);
        return response.data;
    } catch (error) {
        throw error;
    }
};